export function DragHandleCell(props: any) {
  return (
    <td {...props}>
      <span className="k-icon k-i-reorder" style={{ cursor: "move" }} data-drag-handle />
    </td>
  );
}
